import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getOnTimeFulfillmentRate = {
  name: "getOnTimeFulfillmentRate" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
